// Shim: adapts the main app's auth to the shape the ported Budget pages expect.
// The main app is single-tier (no roles) so everyone is treated as admin for
// these internal estimating tools.
// IMPORTANT: the returned object is memoized on the user's identity. The ported
// pages have effects with `user` in their dependency arrays, so returning a new
// object every render would cause infinite render loops.
import { useMemo } from "react";
import { useAuth as useMainAuth } from "@/lib/AuthContext";

export function AuthProvider({ children }) {
  return children;
}

export function useAuth() {
  const { user } = useMainAuth();
  const email = user?.email || "";
  const name = user?.name || (email ? email.split("@")[0] : "");

  return useMemo(() => {
    const [first, ...rest] = (name || "User").split(" ");
    return {
      user: email
        ? {
            id: email,
            email,
            name,
            first_name: first,
            last_name: rest.join(" "),
            role: "admin",
            company: "ABS",
          }
        : null,
      isAdmin: true,
      isAuthenticated: !!email,
      token: (typeof localStorage !== "undefined" && localStorage.getItem("auth_token")) || null,
      loading: false,
      logout: () => {},
    };
  }, [email, name]);
}
